/* MYOP marquee engine — seamless infinite scroll with optional scroll-velocity
   coupling (rAF driven). Markup contract:
     <div class="myop-marquee" data-direction="left|right"
          data-pause-on-hover="true|false" data-speed="45" data-scroll-speed="1">
       <div class="myop-marquee__track">
         <div class="myop-marquee__group"> ...content... </div>
       </div>
     </div>
   The first group is duplicated so a wrap by one group-width loops perfectly.
   - data-speed: seconds for the auto loop (falls back to --marquee-speed var).
   - data-scroll-speed: how strongly page scrolling nudges the marquee (0 = off). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Marquee(root) {
    this.root = root;
    this.track = root.querySelector('.myop-marquee__track');
    if (!this.track) return;
    var group = this.track.querySelector('.myop-marquee__group');
    if (!group) return;

    // Duplicate group once for a seamless loop.
    if (this.track.querySelectorAll('.myop-marquee__group').length < 2) {
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      this.track.appendChild(clone);
    }

    this.dir = root.dataset.direction === 'right' ? 1 : -1;
    this.scrollFactor = parseFloat(root.dataset.scrollSpeed) || 0;
    this.pauseOnHover = root.dataset.pauseOnHover === 'true';
    this.paused = false;
    this.x = 0;
    this.scrollDelta = 0;
    this.lastScrollY = window.scrollY || window.pageYOffset || 0;
    this.last = 0;

    this.measure();

    // Hand control to JS: disable the CSS keyframe animation.
    this.track.style.animation = 'none';
    this.track.style.willChange = 'transform';

    if (reduce) return; // leave static for reduced-motion users

    this.bind();
    this.raf = this.frame.bind(this);
    window.requestAnimationFrame(this.raf);
  }

  Marquee.prototype.measure = function () {
    // Half of the duplicated track = one group width.
    this.groupWidth = this.track.scrollWidth / 2 || this.root.clientWidth;
    var dur = parseFloat(this.root.dataset.speed);
    if (isNaN(dur) || dur <= 0) {
      var cssVar = getComputedStyle(this.root).getPropertyValue('--marquee-speed') ||
                   getComputedStyle(document.documentElement).getPropertyValue('--marquee-speed');
      dur = parseFloat(cssVar) || 45;
    }
    this.autoPxPerMs = this.groupWidth / (dur * 1000);
  };

  Marquee.prototype.bind = function () {
    var self = this;

    if (this.scrollFactor > 0) {
      window.addEventListener('scroll', function () {
        var y = window.scrollY || window.pageYOffset || 0;
        self.scrollDelta += (y - self.lastScrollY);
        self.lastScrollY = y;
      }, { passive: true });
    }

    if (this.pauseOnHover) {
      this.root.addEventListener('mouseenter', function () { self.paused = true; });
      this.root.addEventListener('mouseleave', function () { self.paused = false; });
    }

    var resizeTO;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTO);
      resizeTO = setTimeout(function () { self.measure(); }, 150);
    }, { passive: true });
  };

  Marquee.prototype.frame = function (now) {
    if (!this.last) this.last = now;
    var dt = now - this.last;
    this.last = now;
    if (dt > 100) dt = 16; // tab was backgrounded; avoid a jump

    var move = 0;
    if (!this.paused) move += this.dir * this.autoPxPerMs * dt;       // auto loop
    if (this.scrollFactor) {
      move += this.dir * Math.abs(this.scrollDelta) * this.scrollFactor * (this.scrollDelta < 0 ? -1 : 1);
    }
    this.scrollDelta = 0;

    this.x += move;
    // Normalise into (-groupWidth, 0] so the duplicate keeps it seamless.
    if (this.groupWidth > 0) {
      this.x = this.x % this.groupWidth;
      if (this.x > 0) this.x -= this.groupWidth;
    }
    this.track.style.transform = 'translate3d(' + this.x.toFixed(2) + 'px,0,0)';

    window.requestAnimationFrame(this.raf);
  };

  function initAll(scope) {
    (scope || document).querySelectorAll('.myop-marquee').forEach(function (el) {
      if (el.dataset.myopInit === 'true') return;
      el.dataset.myopInit = 'true';
      new Marquee(el);
    });
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.MyopMarquee = { init: initAll };
})();
